import React from "react";

export default function MSAccess_Max() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Max</h1>
      <p>This is the MSAccess_Max component generated from the SQL JSON.</p>
    </div>
  );
}
